module.exports = __webpack_public_path__ + "img/six-angle.c041ff13.png";